import { render, staticRenderFns } from "./TabelaDeListaDeDados.vue?vue&type=template&id=8ef5faba&scoped=true"
import script from "./TabelaDeListaDeDados.vue?vue&type=script&lang=js"
export * from "./TabelaDeListaDeDados.vue?vue&type=script&lang=js"
import style0 from "./TabelaDeListaDeDados.vue?vue&type=style&index=0&id=8ef5faba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef5faba",
  null
  
)

export default component.exports